import ScaleText from 'react-scale-text'

import CloseButton from '../../../../components/CloseButton/CloseButton'
import { useBlackFriday } from '../../../../context/blackFridayContext'
import useStrings from '../../../../localization/useStrings'
import native from '../../../../native/native'
import svg from '../../../../utils/svg'
import styles from './Header.module.scss'

const Header = () => {
  const strings = useStrings()
  const promoStrings = strings.premiumToUltimateBlackFriday
  const state = useBlackFriday().state
  const savingPercentage = state.ultimatePricing.savingPercent

  const title = state.isUltimateLaunch ? promoStrings.ultimateLaunch.title : promoStrings.title

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <ScaleText>
          <label className={styles.title}>{title}</label>
        </ScaleText>
        <CloseButton
          onClick={() => {
            native.postNativeEvent("close")
          }}
        />
      </div>
      <div className={styles.subtitleContainer}>
        <label className={styles.savingValue}>{savingPercentage}</label>
        <div className={styles.offContainer}>
          <label className={styles.savingPercent}>%</label>
          <label className={styles.savingOff}>{strings.off}</label>
        </div>
      </div>
      <div className={styles.goUltimateContainer}>
        <label>{promoStrings.subTitle}</label>
        <svg.UltimateIcon width={20} height={16} fill="white" />
      </div>
    </div>
  )
}

export default Header
